import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { styled } from '@mui/system'

export const HeaderText = styled(Typography)<{
    theme?: TTheme
    minWidth?: string
}>`
    margin: 12px 0;
    min-width: ${({ minWidth }) => minWidth || '110px'};
`

export const Cell = styled('div')<{
    theme?: TTheme
    status?: TIssueStatus
    minWidth?: string
    maxWidth?: string
    padding?: string
}>`
    cursor: pointer;
    min-width: ${({ minWidth }) => minWidth || 'auto'};
    display: flex;
    align-items: center;
    padding: ${({ padding }) => padding || '0'};
    padding-top: 20px;
    padding-bottom: 20px;
`

export const SubjectCell = styled('div')<{ theme?: TTheme }>`
    cursor: pointer;
    width: 100%;
    padding: 20px 0;

    .table-cell-text {
        font-size: var(--font-size-xs);
        font-style: italic;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        word-break: break-word;
    }
`

export const SenderCell = styled('div')<{
    theme?: TTheme
    status?: TIssueStatus
    minWidth?: string
    maxWidth?: string
}>`
    cursor: pointer;
    width: 100%;
    justify-content: center;
    max-width: ${({ maxWidth }) => maxWidth || '200px'};
    min-width: ${({ minWidth }) => minWidth || 'auto'};
    display: flex;
    flex-direction: column;
    font-size: var(--font-size-xs);
    padding: 20px 0;
`

export const NavigationTitle = styled(Typography)<{ theme?: TTheme }>`
    display: flex !important;
    gap: 16px;
    align-content: center;
    align-items: center;
    padding-left: 40px;
`
